<template>
  <div id="fidelizacion">
    <b-row class="mt-3">
      <b-col xs="6" sm="6" md="6"> 
        <div>
          <h5>Puntos</h5>
          <p class="ml-2">220</p>
        </div>
      </b-col>
      <b-col xs="6" sm="6" md="6"> 
        <div class="text-right">
          <h5>Saldo</h5>
          <p class="ml-2">12.25€</p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12"> 
        <h5>Vales</h5>
          <p class="ml-2">10/10/2020 Ti.024 <span class="float-right">85.00€</span><br>
                          10/10/2020 Ti.024 <span class="float-right">85.00€</span><br>
          </p>
      </b-col>
    </b-row>
  </div>
</template>
<script>

export default {
  name: 'clienteFidelizacion',
  data() {
    return {
      
    }
  },
  methods: {
    
  },
}
</script>